<!-- Send Bulk Whatsapp Modal -->
<p-dialog [visible]="showPopup()" (onHide)="closePopupUp()" [closeOnEscape]="false" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'991px': '100vw'}" [style]="{width: '870px'}" styleClass="no-header-modal" aria-label="send-whatsapp-dialog" data-testid="send-whatsapp-dialog">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="p-3 sticky top-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300">
      @if (whatsAppSendType() === GetWhatsAppSendType.Bulk) {
        <h2 class="mb-0 text-sm" data-testid="bulk-whatsapp-header">{{'SEND_WHATSAPP.SEND_BULK_WHATSAPP' | translate }}</h2>
      }
      @if (whatsAppSendType() === GetWhatsAppSendType.FreeForm) {
        <h2 class="mb-0 text-sm" data-testid="free-form-whatsapp-header" [innerHTML]="'SEND_WHATSAPP.SEND_FREE_FORM_WHATSAPP' | translate : { name: this.SelectedClient().value.full_name } "></h2>
      }
      @if (whatsAppSendType() === GetWhatsAppSendType.Campaign) {
        <h2 class="mb-0 text-sm" data-testid="campaign-whatsapp-header" >{{'SEND_WHATSAPP.WHATSAPP_CONFIG' | translate }}</h2>
      }
      @if (whatsAppSendType() === GetWhatsAppSendType.Automation) {
        <h2 class="mb-0 text-sm" data-testid="automation-whatsapp-header" >{{'SEND_WHATSAPP.WHATSAPP_CONFIG' | translate }}</h2>
      }
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopupUp()" aria-label="close-whatsapp-dialog" data-testid="close-whatsapp-dialog"></div>
    </div>
    <!-- Header -->
    <form [formGroup]="sendWhatsAppForm">
      <!-- Show skeleton when loading -->
      @if (loading) {
        <div class="p-3 surface-100" data-testid="whatsapp-form-skeleton">
          <!-- Automation Schedule Type Skeleton -->
          <div class="mb-3">
            <p-skeleton width="100%" height="120px" />
          </div>
          <div class="surface-0 shadow-3 border-round relative text-sm">
            <!-- Campaign Toggle Skeleton -->
            <div class="flex align-items-center mb-2">
              <p-skeleton width="120px" height="24px" styleClass="mr-2" />
              <p-skeleton width="40px" height="24px" />
            </div>
            <div class="surface-0 shadow-3 p-3 border-round text-sm">
              <!-- From Dropdown Skeleton -->
              <div class="pl-6 relative mb-2">
                <p-skeleton width="40px" height="16px" styleClass="absolute left-0 top-0 mt-2" />
                <p-skeleton width="100%" height="35px" />
              </div>
              <!-- Mobile Numbers Section Skeleton -->
              <div class="mb-3">
                <p-skeleton width="120px" height="16px" styleClass="mb-2" />
                <div class="flex flex-wrap align-items-center">
                  <p-skeleton width="150px" height="35px" styleClass="m-2" />
                  <p-skeleton width="150px" height="35px" styleClass="m-2" />
                  <p-skeleton width="150px" height="35px" styleClass="m-2" />
                  <p-skeleton width="150px" height="35px" styleClass="m-2" />
                  <p-skeleton width="120px" height="24px" styleClass="ml-3" />
                </div>
              </div>
              <!-- Template Selection Skeleton -->
              <div class="mb-3">
                <p-skeleton width="140px" height="16px" styleClass="mb-2" />
                <p-skeleton width="100%" height="35px" />
              </div>
              <!-- Message Area Skeleton -->
              <div class="mb-3">
                <p-skeleton width="80px" height="16px" styleClass="mb-2" />
                <p-skeleton width="100%" height="112px" />
              </div>
              <!-- Marketing Message Toggle Skeleton -->
              <div class="flex align-items-center justify-content-between">
                <div class="flex align-items-center">
                  <p-skeleton width="40px" height="24px" />
                  <p-skeleton width="200px" height="24px" styleClass="ml-3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Footer Skeleton -->
      @if (loading) {
        <div class="p-3 sticky bottom-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-top-1 border-300">
          <p-skeleton width="100px" height="35px" />
          <p-skeleton width="120px" height="35px" />
        </div>
      }

      <!-- Show actual content when not loading -->
      @if (!loading) {
        <div>
          @if (whatsAppSendType() === GetWhatsAppSendType.Automation && showScheduleType.value) {
            <automation-schedule-type [formGroup]="sendWhatsAppForm" [automationMaster]="automationMaster()" [type]="'WHATSAPP'" aria-label="automation-schedule-type" data-testid="automation-schedule-type" />
          }
          <!-- Content -->
          <div class="p-3 surface-100">
            @if (showCampaign.value && whatsAppSendType() === GetWhatsAppSendType.Bulk) {
              <div class="flex align-items-center mb-2">
                <strong class="text-sm mb-0 mr-2 -mt-1 cursor-pointer" data-testid="campaign-toggle-label">{{'SEND_WHATSAPP.IS_CAMPAIGNS' | translate }}</strong>
                <p-toggleSwitch formControlName="is_visible" aria-label="campaign-visibility-toggle" data-testid="campaign-visibility-toggle" />
              </div>
            }
            <div class="surface-0 shadow-3 border-round relative text-sm">
              <!-- Campaign Fields Section -->
              @if (IsVisibleFormControl.value && whatsAppSendType() === GetWhatsAppSendType.Bulk) {
                <div class="p-3">
                  <!-- Form Group -->
                  <div class="mb-3">
                    <label for="campaign-name-input" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="campaign-name-label">{{'SEND_WHATSAPP.CAMPAIGN_NAME' | translate }}</label>
                    <input type="text" formControlName="campaign_name" class="text-sm w-full" pInputText [placeholder]="'SEND_EMAIL.NAME_PLACEHOLDER' | translate" [ngClass]="{ 'ng-invalid ng-dirty': CampaignNameFormControl.invalid && CampaignNameFormControl.touched }" aria-label="campaign-name-input" data-testid="campaign-name-input" />
                    @if (CampaignNameFormControl.touched && CampaignNameFormControl.invalid) {
                      <app-error-msg [errors]="CampaignNameFormControl.errors" [fieldLabel]="'SEND_EMAIL.CAMPAIGN_NAME_ERROR' | translate" data-testid="campaign-name-error" />
                    }
                  </div>
                  <!-- Form Group -->
                  
                  <!-- Form Group -->
                  <div class="mb-3">
                    <label for="campaign-description-input" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="campaign-description-label">{{'SEND_WHATSAPP.CAMPAIGN_DESCRIPTION' | translate }}</label>
                    <textarea pInputTextarea formControlName="campaign_description" class="text-sm w-full h-4rem" [placeholder]="'SEND_EMAIL.DESC_PLACEHOLDER' | translate" [ngClass]="{ 'ng-invalid ng-dirty': CampaignDescriptionFormControl.invalid && CampaignDescriptionFormControl.touched }" aria-label="campaign-description-input" data-testid="campaign-description-input"></textarea>
                    @if (CampaignDescriptionFormControl.touched && CampaignDescriptionFormControl.invalid) {
                      <app-error-msg [errors]="CampaignDescriptionFormControl.errors" [fieldLabel]="'SEND_EMAIL.CAMPAIGN_DESCRIPTION_ERROR' | translate" data-testid="campaign-description-error" />
                    }
                  </div>
                  <!-- Form Group -->
                  
                  <!-- Form Group -->
                  <div class="mb-0">
                    <label for="schedule-date-input" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="schedule-date-label">{{'SEND_WHATSAPP.SCHEDULE_DATE_ERROR' | translate }}</label>
                    <p-datepicker [showIcon]="true"
                      formControlName="campaign_action_date"
                      icon="fa fa-calendar font-light"
                      dateFormat="M dd,yy"
                      [yearNavigator]="true"
                      yearRange="2023:2030"
                      [placeholder]="'SEND_EMAIL.CHOOSE_DATE' | translate"
                      inputStyleClass="text-sm"
                      [ngClass]="{ 'ng-invalid ng-dirty': CampaignActionDateFormControl.invalid && CampaignActionDateFormControl.touched }"
                      aria-label="schedule-date-input"
                      data-testid="schedule-date-input"
                     />
                    @if (CampaignActionDateFormControl.touched && CampaignActionDateFormControl.invalid) {
                      <app-error-msg [errors]="CampaignActionDateFormControl.errors" [fieldLabel]=" 'SEND_EMAIL.SCHEDULE_DATE' | translate" data-testid="schedule-date-error" />
                    }
                  </div>
                  <!-- Form Group -->
                </div>
              }
              
              <!-- Content Label -->
              @if (showCampaign.value && whatsAppSendType() === GetWhatsAppSendType.Bulk) {
                <div class="px-3 pt-3 pb-2">
                  <label for="content-input" class="font-medium text-700 text-xs mb-0 block uppercase" data-testid="content-label">{{'SEND_WHATSAPP.CONTENT' | translate }}</label>
                </div>
              }
              
              <!-- Content Section -->
              <div class="surface-0 shadow-3 p-3 border-round text-sm">
              <!-- From -->
              <div class="pl-6 relative mb-2">
                <span class="absolute left-0 top-0 mt-2" data-testid="from-whatsapp-label">{{'SEND_SMS.FROM' | translate }}</span>
                <p-select [options]="whatsAppFrom" formControlName="whatsapp_from" optionLabel="display_phonenumber" filterBy="display_phonenumber" styleClass="text-sm text-black-alpha-90 w-full" [ngClass]="{ 'ng-invalid ng-dirty': SelectedWhatsAppFromFormControl.invalid && SelectedWhatsAppFromFormControl.touched }" aria-label="from-whatsapp-dropdown" data-testid="from-whatsapp-dropdown">
                  <ng-template pTemplate="selectedItem">
                    @if (SelectedWhatsAppFromFormControl.value) {
                      <strong class="text-sm">{{ SelectedWhatsAppFromFormControl.value.display_phonenumber }}</strong>
                    }
                  </ng-template>
                  <ng-template let-whatsappsender pTemplate="item">
                    <div class="text-sm">{{ whatsappsender.display_phonenumber }} {{whatsappsender.isCorporate ? '(Corporate)' : ''}}</div>
                  </ng-template>
                </p-select>
              </div>
              <!-- From -->
              <!-- Form Group -->
              @if (whatsAppSendType() !== GetWhatsAppSendType.Campaign &&  whatsAppSendType() !== GetWhatsAppSendType.Automation) {
                <div class="mb-3">
                  <label for="to-whatsapp-input" class="font-medium text-700 text-xs mb-0 block uppercase" data-testid="to-whatsapp-label">{{'SEND_WHATSAPP.MOBILE_NUMBER' | translate }}</label>
                  <div class="flex align-items-center flex-wrap text-sm line-height-1">
                    @for (mobileNumber of getClientMobileNos() | slice:0:4; track mobileNumber) {
                      <span class="bg-primary text-center p-2 border-round mr-2 mt-2">
                        {{ mobileNumber }}
                      </span>
                    }
                    @if (getClientMobileNos().length > 4) {
                      <div
                        class="text-primary ml-3 mt-2"
                        [innerHTML]="'SEND_EMAIL.TOTAL_RECORDS' | translate : { count : selectedAllData().value ? totalRecords().value : getClientMobileNos().length }"
                        data-testid="total-recipients"
                      ></div>
                    }
                  </div>
                </div>
              }
              <!-- Form Group -->
              <!-- Form Group -->
              <div class="mb-3"
                >
                <label for="choose-template-input" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="choose-template-label">{{'SEND_WHATSAPP.CHOOSE_TEMPLATE' | translate }}</label>
                <p-select
                  [options]="whatsappTemplateMasters$.value"
                  formControlName="whatsapp_template"
                  dropdownIcon="fa fa-chevron-down"
                  optionLabel="template_name"
                  filterBy="template_name"
                  styleClass="text-sm w-full"
                  optionDisabled="not_approved"
                  appendTo="body"
                  [placeholder]="'SEND_EMAIL.CHOOSE_TEMPLATE' | translate"
                  [emptyMessage]="whatsAppSendType() === GetWhatsAppSendType.Automation ? ('SEND_EMAIL.NO_TEPLATE_FOR_EVENT' | translate : { event_type: automationMaster().value.friendly_name }) : ('SEND_EMAIL.NO_TEMPLATE_FOUND' | translate)"
                  (onChange)="SelectWhatsAppTemplate()"
                  aria-label="whatsapp-template-dropdown"
                  data-testid="whatsapp-template-dropdown">
                  <ng-template pTemplate="selectedItem">
                    @if (SelectedWhatsAppTemplateFormControl.value) {
                      <strong class="text-sm text-primary">{{ SelectedWhatsAppTemplateFormControl.value.template_name }}</strong>
                    }
                  </ng-template>
                  <ng-template let-template pTemplate="item">
                    <div class="text-sm">{{ template.template_name }}</div>
                  </ng-template>
                </p-select>
                @if (SelectedWhatsAppTemplateFormControl.touched && SelectedWhatsAppTemplateFormControl.invalid) {
                  <app-error-msg [errors]="SelectedWhatsAppTemplateFormControl.errors" [fieldLabel]="'SEND_WHATSAPP.TEMPLATE' | translate" data-testid="template-error" />
                }
              </div>
              <!-- Form Group -->
              <!-- Form Group -->
              <div class="mb-3">
                <label for="message-input" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="message-label">{{'SEND_EMAIL.CONTENT' | translate }}</label>
                <textarea pInputTextarea class="text-sm w-full h-7rem" formControlName="body" placeholder="The maximum limit for text is 300 characters..." [ngClass]="{ 'ng-invalid ng-dirty': BodyFormControl.invalid && BodyFormControl.touched }" aria-label="whatsapp-message-editor" data-testid="whatsapp-message-editor"></textarea>
                @if (BodyFormControl.touched && BodyFormControl.invalid) {
                  <app-error-msg [errors]="BodyFormControl.errors" [fieldLabel]="'SEND_EMAIL.CONTENT_LABEL' | translate" data-testid="message-error" />
                }
              </div>
              <!-- Form Group -->
              @if (whatsAppSendType() === GetWhatsAppSendType.FreeForm) {
                <div class="flex align-items-center justify-content-between">
                  <div class="flex align-items-center justify-content-end">
                    <div class="flex align-items-center">
                      <p-toggleSwitch formControlName="is_marketing_message" />
                      <label for="is-marketing-message-label" class="ml-3 -mt-1 flex align-items-center">
                        {{'SEND_EMAIL.NOT_MARKETING_MSG' | translate }}
                        <i class="fa fa-circle-question text-base text-600 cursor-pointer ml-2" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i>
                      </label>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
          <!-- Content -->
          <!-- Modal Footer -->
          <div class="p-3 sticky bottom-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-top-1 border-300">
            <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-link text-sm" (click)="closePopupUp()" aria-label="cancel-whatsapp-button" data-testid="cancel-whatsapp-button" />
            @if (whatsAppSendType() !== GetWhatsAppSendType.Campaign && whatsAppSendType() !== GetWhatsAppSendType.Automation) {
              <p-button [label]="'SEND_WHATSAPP.SEND_WHATSAPP' | translate" [disabled]="!isFormValid" [loading]="btnLoading" styleClass="text-sm" (click)="SendWhatsApp()" aria-label="send-whatsapp-button" data-testid="send-whatsapp-button" />
            }
            @if (whatsAppSendType() === GetWhatsAppSendType.Campaign || whatsAppSendType() === GetWhatsAppSendType.Automation) {
              <p-button [label]="'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate" [disabled]="!isFormValid" [loading]="btnLoading" styleClass="text-sm" (click)="SaveData()" aria-label="submit-whatsapp-button" data-testid="submit-whatsapp-button" />
            }
          </div>
          <!-- Modal Footer -->
        </div>
      }
    </form>
  </ng-template>
</p-dialog>
<!-- Send Bulk Whatsapp Modal -->
